'use client';

import React from 'react';
import { getColorClassNames, cx, Color, colorPalette } from '@UI/lib/utils';

interface CalloutProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  icon?: React.ElementType;
  color?: Color;
}

const Callout = React.forwardRef<HTMLDivElement, CalloutProps>((props, ref) => {
  const { title, icon, color, className, children, ...other } = props;

  const Icon = icon;
  return (
    <div
      ref={ref}
      className={cx(
        // common
        'flex flex-col overflow-hidden rounded-revving-default text-revving-default border-l-4 py-3 pr-3 pl-4',
        // colorize
        color
          ? cx(
              getColorClassNames(color, colorPalette.background).bgColor,
              getColorClassNames(color, colorPalette.darkBorder).borderColor,
              getColorClassNames(color, colorPalette.darkText).textColor,
              'dark:bg-opacity-10 bg-opacity-10',
            )
          : cx(
              // light
              'bg-revving-brand-faint border-revving-brand-emphasis text-revving-brand-emphasis',
              // dark
              'dark:bg-darkRevving-brand-muted/70 dark:border-darkRevving-brand-emphasis dark:text-darkRevving-brand-emphasis',
            ),
        className,
      )}
      {...other}
    >
      <div className="flex items-start">
        {Icon ? <Icon className="flex-none h-5 w-5 mr-1.5" /> : null}
        <h4 className="font-accent">{title}</h4>
      </div>
      <p className={cx('overflow-y-auto', children ? 'mt-2' : '')}>
        {children}
      </p>
    </div>
  );
});

Callout.displayName = 'Callout';

export { Callout, type CalloutProps };
